module.exports = __webpack_public_path__ + "static/media/home.d56c3f25.svg";